// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-404-dumpster-js": () => import("./../../../src/templates/404-dumpster.js" /* webpackChunkName: "component---src-templates-404-dumpster-js" */),
  "component---src-templates-dumpster-index-js": () => import("./../../../src/templates/dumpster-index.js" /* webpackChunkName: "component---src-templates-dumpster-index-js" */),
  "component---src-templates-pro-registration-js": () => import("./../../../src/templates/pro-registration.js" /* webpackChunkName: "component---src-templates-pro-registration-js" */)
}

